const HeaderDefaultConfig = {
  headerClasses:
    "light-header site-header site-header--menu-end site-header--button-sep site-header--sticky position-relative",
  containerFluid: false,
  darkLogo: true,
}
export default HeaderDefaultConfig
